<template>
    <div class="container">
        <div class="col-md-12">
            <h2> {{ labels.title }} </h2>
        </div>
        <div class="col-md-12 d-flex justify-content-end">
            <md-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary" @click="createActivo()">
                <md-icon>add</md-icon>
            </md-button>
        </div>
        <div class="row col-md-12 justify-content-center mt-3" v-if="activos.length != 0">
            <b-table
                :items="activos"
                :fields="fields"
                hover
                bordered
                responsive
                sticky-header="500px"
                small
                class="tblEstandar"
                head-variant="custom-blue"
                :per-page="perPage"
                :current-page="currentPage"
                @row-clicked="(item) => editActivo(item.id)"
            >
                <template #cell(tipo_activo)="data">
                    <div class="text-left">{{ nameTipoActivo(data.item.tipo_activo) }}</div>
                </template>
            </b-table>
            <div class="row col-12 mt-1">
                <div class="col-10 d-flex justify-content-center">
                    <b-pagination
                    v-model="currentPage"
                    :total-rows="activos.length"
                    :per-page="perPage"
                    align="center"
                    size="md"
                    class="custom-pagination"
                    ></b-pagination>
                </div>
                <div class="col-2 d-flex justify-content-end">
                    <label class="mr-2 mb-0">Filas por página:</label>
                    <b-form-select
                        v-model="perPage"
                        :options="[5, 10, 20, 50, 100, 500]"
                        size="sm"
                        style="width: 80px;"
                    ></b-form-select>
                </div>
            </div>
        </div>
        <div class="row col-md-12 justify-content-center mt-3" v-else>
            <h5>{{ labels.noRow }}</h5>
        </div>
        <Crear :modalCrear="showModCrear" @cierraModal="closeModal"></Crear>
        <Editar :modalEditar="showModEditar" :infoEditAct="dataActivo" @cierraModal="closeModal"/>
    </div>
</template>

<script>
import Activos from '../../services/Activos';
import TipoActivo from '../../services/TipoActivo';
import Crear from './Crear';
import Editar from './Editar';

export default {
    name:'TipoActivo',
    components:{Crear,Editar},
    data:() => ({
        activos : [],
        showModCrear : false,
        listTipoActivo : [],
        dataActivo : [],
        showModEditar : false,
        perPage: 500,
        currentPage: 1,
        fields: [
            {key: 'activo', label: 'Código', sortable: false},
            {key: 'tipo_activo', label: 'Tipo activo', sortable: false},
            {key: 'descripcion', label: 'Descripción', sortable: false},
            {key: 'fecha_compra', label: 'Fecha compra', sortable: false}
        ]
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Activos",
                    codigo : "Código",
                    tipo_activo : "Tipo activo",
                    descripcion : "Descripción",
                    fecha_compra : "Fecha compra",
                    noRow : "No hay registros"
                }
            }else{
                return {
                    title: "Assets",
                    codigo : "Code",
                    tipo_activo : "Active type",
                    descripcion : "Description",
                    fecha_compra : "Purchase date",
                    noRow : "There are not records"
                }
            }
        }
    },
    methods:{
        createActivo(){
            this.showModCrear = true
        },
        editActivo(id){
            // console.log('editActivo: ',id);
            Activos.getActivoById(id)
            .then((res) => {
                // console.log(res.data.infoActivo);
                this.dataActivo = res.data.infoActivo
                this.showModEditar = true
            })
            .catch((error) => { console.log(error) })
        },
        closeModal(val){
            this.showModCrear = val
            this.showModEditar = val
        },
        nameTipoActivo(idTipAct){
            // console.log(idTipAct);
            let tipoActivo = this.listTipoActivo.find((tipAct) => tipAct.tipo_activo === idTipAct)
            return tipoActivo.descripcion
        }
    },
    mounted(){
        Activos.getAllActivos()
        .then((res) => {
            // console.log(res.data.listActivos);
            this.activos = res.data.listActivos
        })
        .catch((err) => { console.log(err)})

        TipoActivo.getAllTipoActivo()
        .then((res) => {
            // console.log(res.data.listTipoActivo);
            this.listTipoActivo = res.data.listTipoActivo
        })
        .catch((err) => { console.log(err)})
    }
}
</script>

<style>

</style>